/* GENIC - two PDP behaviour overrides that live outside genic-pdp-app.js.
   That file is 17KB of PDP logic, carousel physics and option rendering; neither fix
   below requires touching it. To revert one, delete its block. To revert both, delete
   this file and the one script tag in layout/theme.liquid. Nothing else depends on it.

   ------------------------------------------------------------------------------
   FIX 1 - restore the cart drawer on add-to-cart. Ryan, Jul 25 2026.
   Supersedes the Jul 22 toast-only confirmation implemented by
   genicSuppressDrawerAutoOpen() in genic-pdp-app.js.

   Why: add-to-cart -> reached-checkout fell 67.7% to 50.6% across the Jul 21-23
   relaunch. It is the only funnel step that measurably moved. The toast rendered
   310px below the button, low contrast, over an editorial photograph, with no
   next step.

   Mechanism: genic-pdp-app.js dispatches cart:update with detail.sourceId
   'genic-pdp' AFTER the add succeeds and the authoritative item count is read. We
   open on that event so the panel renders with the item already in it, and we call
   open() directly rather than relying on the auto-open attribute, which that file
   strips on add.

   NOTE: deliberately setTimeout, not requestAnimationFrame. rAF does not fire in a
   backgrounded tab, which silently swallowed the first version of this fix.

   ------------------------------------------------------------------------------
   FIX 2 - expressCheckout() can no longer destroy the cart. Cindy, Jul 25 2026.

   READ THIS BEFORE DELETING IT: there is currently NO caller for expressCheckout()
   in the draft theme. That is intentional and does not make this block dead code.

   The original expressCheckout() in genic-pdp-app.js navigates to
   '/cart/{variantId}:1'. That is a Shopify cart PERMALINK, which by design REPLACES
   the whole cart instead of adding to it. Reproduced Jul 25: a cart holding 8 items
   worth $425 became 1 item worth $34 on a single tap, and it never reached checkout -
   it landed back on the product page.

   The BUY NOW button that called it was REMOVED from sections/genic-pdp.liquid on
   Jul 25 by Ryan's decision, so this override has no caller here. It stays for two
   reasons:
     1. The function is still defined in genic-pdp-app.js, which is byte-identical in
        the published theme (md5 b59d5971a928f10714ed7abb30ee473c). Until that theme
        is replaced, this file is the safety net wherever it loads.
     2. If anyone re-adds a Buy Now button on any surface, it inherits the safe
        behaviour automatically instead of silently wiping carts again.

   Safe behaviour: add the selected option to the cart normally, preserving whatever
   is already there, then go straight to /checkout - skipping the cart page, which is
   what a Buy Now is for. Verified Jul 25: cart of 2 items became 3 and reached
   checkout.

   Reading the selection: selectedOpt is a closure-local in genic-pdp-app.js and not
   reachable from here, so we read it from the DOM instead - the app marks the chosen
   tile with class 'sel'. Single-option products render no tiles, so we fall back to
   CFG.preselect and then to index 0. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- FIX 1 */

  var SETTLE_MS = 80;
  var opening = false;

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) {
      opening = false;
      return;
    }

    var go = function () {
      try {
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else if (typeof drawer.showDialog === 'function') {
          drawer.showDialog();
        }
      } catch (e) {
        /* never let a drawer failure break add-to-cart */
      }
      opening = false;
    };

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer-component').then(go, go);
    } else {
      go();
    }
  }

  document.addEventListener('cart:update', function (event) {
    var detail = event && event.detail;
    if (!detail || detail.sourceId !== 'genic-pdp') return;
    if (opening) return;
    opening = true;
    /* let cart-items-component morph its sections before the panel is shown */
    setTimeout(openDrawer, SETTLE_MS);
  });

  /* ---------------------------------------------------------------- FIX 2 */

  function selectedOption() {
    var CFG = window.GENIC_PDP || {};
    var opts = CFG.options || [];
    if (!opts.length) return null;

    var tiles = document.querySelectorAll('#p-opts .opt');
    var idx = -1;

    for (var i = 0; i < tiles.length; i++) {
      if (tiles[i].classList.contains('sel')) { idx = i; break; }
    }
    if (idx < 0) {
      idx = (typeof CFG.preselect === 'number') ? CFG.preselect : 0;
    }
    return opts[idx] || opts[0] || null;
  }

  window.expressCheckout = function () {
    var o = selectedOption();
    if (!o || !o.variantId) return;

    var btn = null;
    try {
      btn = [].slice.call(document.querySelectorAll('button')).filter(function (b) {
        return /BUY NOW/i.test(b.textContent || '');
      })[0] || null;
    } catch (e) {}
    var restore = btn ? btn.textContent : null;
    if (btn) btn.textContent = 'ONE MOMENT';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: o.variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        /* straight to payment - the point of a Buy Now */
        window.location = '/checkout';
      })
      .catch(function () {
        if (btn && restore !== null) btn.textContent = restore;
      });
  };
})();
